import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Products List
export const getProductList = createAsyncThunk(
  "getProductList",
  async (
    { search, pageLimit, pageCount, categories_ids, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `products?search=${search}&categories_ids=[${categories_ids?.join(
          ","
        )}]&page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Edit Products
export const createProduct = createAsyncThunk(
  "createProduct",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`product-interset`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Categories List
export const getCategoriesList = createAsyncThunk(
  "getCategoriesList",
  async ({ search, limit }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `categories?search=${search}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const productsSlice = createSlice({
  name: "products",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // get Products List
      .addCase(getProductList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductList.fulfilled, (state, action) => {
        state.loading = false;
        state.getProductListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getProductList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      .addCase(createProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.createProductStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createProduct.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Categories List
      .addCase(getCategoriesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategoriesList.fulfilled, (state, action) => {
        state.loading = false;
        state.getCategoriesListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCategoriesList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = productsSlice;
export default reducer;
